<script lang="ts">
import { defineComponent, PropType, ref, watch, onMounted } from 'vue'

export default defineComponent({
  name: 'TextareaDefault',

  props: {
    /**
     * フォームの name 属性
     */
    name: {
      type: String,
      default: '',
    },

    /**
     * 初期状態が bind される value
     */
    modelValue: {
      type: String,
      default: '',
    },

    /**
     * placeholder テキスト
     */
    placeholder: {
      type: String,
      default: '',
    },

    /**
     * autocomplete 属性に渡す値
     * @see https://developer.mozilla.org/ja/docs/Web/HTML/Attributes/autocomplete
     */
    autocomplete: {
      type: String as PropType<AutocompleteAttr>,
      default: 'off',
    },

    /**
     * textarea の rows 属性値
     */
    rows: {
      type: Number,
      default: 6,
    },

    /**
     * disabled 属性にわたす非活性フラグ
     */
    isDisabled: {
      type: Boolean,
      default: false,
    },

    /**
     * エラー発生状態かどうか
     * ※ エラー状態は外から受け取る
     */
    isError: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue'],

  setup(props) {
    const localValue = ref('')

    watch(() => props.modelValue, (newValue) => {
      if (localValue.value !== newValue) localValue.value = newValue
    })

    onMounted(() => {
      localValue.value = props.modelValue
    })

    return {
      // data
      localValue,
    }
  }
})
</script>

<template>
  <textarea
    v-model="localValue"
    class="textarea"
    :name="name ? name : undefined"
    :placeholder="placeholder"
    :rows="rows"
    :disabled="isDisabled"
    :autocomplete="autocomplete"
    :data-is-error="isError"
    @input="$emit('update:modelValue', localValue)" />
</template>
